// extracted by mini-css-extract-plugin
export default {"container":"pN-z","topReviewHeading":"qN-z","criticalReview":"rN-z","favorableReview":"sN-z","vsSeparator":"tN-z"};